'use strict';
// Keep the shuffle on screen while a sloth is being dealt, from the top of the page.
const homeView = VIEWS.home;
VIEWS.home = function(){ return S.adopting ? adoptView() : homeView.call(VIEWS); };
const adoptSloth = adopt;
adopt = async function(p){ window.scrollTo(0, 0); return adoptSloth(p); };
const chromeView = renderChrome;
renderChrome = function(){ chromeView(); if (S.adopting) $chip.innerHTML = ''; };
// Copy: every sloth is a unique hand-painted portrait.
const adoptCopy = adoptView;
adoptView = function(){ return adoptCopy().replace('one of ' + PORTRAITS.length + ' hand-painted portraits', 'a unique hand-painted portrait'); };
const galleryView = VIEWS.gallery;
VIEWS.gallery = function(){ return galleryView.call(VIEWS).replace(PORTRAITS.length + ' hand-painted portraits, each hung in a different frame, finish, mat and varnish, and each with its own personality.', 'Every sloth is a unique hand-painted portrait, hung in its own frame, finish, mat and varnish, with its own personality.'); };
// Copy: sign-up sheet.
const joinCopy = joinSheet;
joinSheet = function(){ return joinCopy()
  .replace('JOIN THE <span class="ol">SLOMMUNITY.</span>', 'YOUR SLOTH IS <span class="ol">WAITING.</span>')
  .replace('Create your account, then we’ll deal you one of 10,000 sloths. It’s free.', 'Somewhere among 10,000 hand-painted sloths is one with your name on it. Join free and we’ll deal you yours: framed, named and registered to you for good. When they’re gone, they’re gone.'); };